export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50">
              香香漫画
            </span>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              香香漫画网，提供香香漫画官网入口与网址，海量韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全，下拉式追更体验，安全直达。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {['人气榜单', '编辑精选', '漫画索引', '近期快讯'].map((item, i) => (
                <li key={i}>
                  <a
                    href={`#${['ranking', 'carousel', 'index', 'updates'][i]}`}
                    className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              漫画类型
            </h4>
            <ul className="space-y-2.5">
              {['韩漫', '日漫', '国漫', '下拉式漫画'].map((item, i) => (
                <li key={i}>
                  <a
                    href="#index"
                    className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-400">
              合作洽谈中，敬请期待
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 香香漫画网 版权所有
          </p>
          <p className="text-xs text-background-500">
            香香漫画官网入口 - 安全直达，免费阅读
          </p>
        </div>
      </div>
    </footer>
  );
}